const defaultSiteValues = {
  currentStation:""
}

const getStation = () => {
  return defaultSiteValues.currentStation;
}

const setStation = (station) => {
  defaultSiteValues.currentStation = station;
  return defaultSiteValues.currentStation;
}

const getApiSitePrefix = () => {
  let siteUrl = process.env.REACT_APP_SERVER_URL;
  let localPort = process.env.REACT_APP_LOCAL_PORT || 3001;
  if (process.env.REACT_APP_FORCE_SERVER === "true") return siteUrl;
  if (window.location.hostname === "localhost") siteUrl=`http://localhost:${localPort}`;
  if (window.location.hostname.substr(0, 4) === "192.") siteUrl=`http://${window.location.hostname}:${localPort}`;
  return siteUrl;
};

export {
  getStation,
  setStation,
  getApiSitePrefix
};
